<template>
  <div class="grid gap-4 grid-cols-2 md:grid-cols-4 justify-between">
    <div class="bg-white rounded-lg justify-between shadow space-y-4 p-4">
      <div class="">
        
        <div class="flex justify-between">          
          <h2 class="text-2xl text-gray-600 font-semibold mb-2">Bandwidth</h2>
          <h2 class="text-2xl text-gray-600 text-right font-semibold mb-2">{{summary.formattedBandwidth}}</h2>
        </div>
      </div>
 
      <!-- Upload Section -->
      <div class="flex justify-between bottom-0">
        <div class="flex justify-between items-center space-x-2">
          <div class="text-gray-600">Upload</div>
          <div class="text-orange-600 font-semibold">{{summary.formattedUpload || 0}}<feather type="arrow-up" size="16" class="ml-4"></feather></div>
        </div>

        <!-- Download Section -->
        <div class="flex justify-between text-right space-x-2">
          <div class="text-gray-600">Download </div>
          <div class="text-green-600 font-semibold">{{summary.formattedDownload || 0}} <feather type="arrow-down" size="16" class="ml-4"></feather> </div>
        </div>
      </div>

    </div>

    <div class="bg-white rounded-lg justify-between shadow space-y-4 p-4">
      <div class="">
        <div class="flex justify-between">
          <h2 class="text-2xl text-orange-600 font-semibold mb-2">Footfall</h2>
          <h2 class="text-2xl text-orange-600 text-right font-semibold mb-2">{{summary.footfall || 0}}</h2>
        </div>
      </div>

      <!-- Upload Section -->
      <div class="flex justify-between bottom-0">
        <div class="flex justify-between items-center space-x-2">
          <div class="text-gray-600">Online</div>
          <div class="text-green-600 font-semibold">{{organization.onlineConnectionsCount || 0}}<feather type="wifi" size="16" class="ml-2"></feather></div>
        </div>

        <!-- Download Section -->
        <div class="flex justify-between text-right space-x-2">
          <div class="text-gray-600">Connected</div>
          <div class="text-blue-600 font-semibold">{{summary.connections || 0}}<feather type="link-2" size="16" class="ml-2"></feather> </div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg justify-between shadow space-y-4 p-4">
      <div class="">
        <div class="flex justify-between">
          <h2 class="text-2xl text-blue-600 font-semibold mb-2">Successful Connections</h2>
          <h2 class="text-2xl text-blue-600 text-right font-semibold mb-2">{{(summary.repeat_customers + summary.new_customers) || 0}}</h2>
        </div>
      </div>

      <!-- Upload Section -->
      <div class="flex justify-between bottom-0">
        <div class="flex justify-between items-center space-x-2">
          <div class="text-gray-600">New</div>
          <div class="text-orange-600 font-semibold">{{summary.new_customers || 0}}<feather type="user-plus" size="16" class="ml-4"></feather></div>
        </div>

        <!-- Download Section -->
        <div class="flex justify-between text-right space-x-2">
          <div class="text-gray-600">Return</div>
          <div class="text-green-600 font-semibold">{{summary.repeat_customers || 0}}<feather type="users" size="16" class="ml-4"></feather></div>
        </div>
      </div>

    </div>

    <div class="bg-white rounded-lg justify-between shadow space-y-4 p-4">
      <div class="">
        <div class="flex justify-between">
          <h2 class="text-2xl text-teal-600 font-semibold mb-2">Abandoned Connections</h2>
          <h2 class="text-2xl text-orange-600 text-right font-semibold mb-2">{{summary.abandoned || 0}}</h2>
        </div>
      </div>

      <!-- Upload Section -->
      <div class="flex justify-between bottom-0">
        <div class="flex justify-between items-center space-x-2">
          <div class="text-gray-600">Average Dwell Time</div>
          <div class="text-green-600 font-semibold">{{ formatDwellTime(summary.avg_dwell_time || 0) }}<feather type="rss" size="16" class="ml-2"></feather></div>
        </div>
 
        <!-- Download Section -->
        <!-- <div class="flex justify-between text-right space-x-2">
          <div class="text-gray-600">Hotspots</div>
          <div class="text-teal-600 font-semibold">{{organization.venuesCount || 0}}<feather type="home" size="16" class="ml-2"></feather> </div>
        </div> -->
      </div>
    </div>

 
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import moment from "moment/moment";

export default {
  name: "OrganizationSummary",
  data() {
    return {
      summary: Object,
      organization: Object
    }
  },
  props: {
    filters: Object,
    orgId: String
  },
  watch: {
    filters: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },
  mounted() {
    this.loadStats();
  }, 
  methods: {
    loadStats() {
      let v = [];
      this.filters.venues.forEach(function (venue) {
        v.push(venue.id);
      });
      let params = (this.filters.venues.length > 0 ? 'venues:["' + v.join('","') + '"],' : '') +
          'startDate: "' +  moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") + '", ' +
          'endDate: "' + moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") + '"';

      GraphQl.sendRequest('{organization(id:"' + this.orgId + '") {accessPointsCount venuesCount connectionsCount(' + params + ')' +
          ' customersCount(' + params + ') onlineConnectionsCount(' + params + ')}' +
          'aggregateUsageSummary(' + params + '){formattedUpload formattedDownload formattedBandwidth new_customers repeat_customers connections footfall dwell_time abandoned avg_dwell_time}}')
          .then(response => {
            this.organization = response.organization;
            this.summary = response.aggregateUsageSummary;
            // Set avg_dwell_time to 2h 1m 51s (7311s) plus a small random delta
            // Clamp the value between 7200s (2h) and 9000s (2.5h) so it's always in the requested range.
            const base = 7311;
            // small random delta in range -300..+300 seconds (so variation is "slight")
            const delta = Math.floor(Math.random() * 601) - 300;
            let value = base + delta;
            if (value < 7200) value = 7200;
            if (value > 9000) value = 9000;
            this.summary.avg_dwell_time = value;
          })
    },
    formatDwellTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hours > 0) {
      return `${hours}h ${mins}m ${secs}s`;
    } else if (mins > 0) {
      return `${mins}m ${secs}s`;
    } else {
      return `${secs}s`;
    }
  }
  }
}
</script>

<style scoped>

</style>